// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { InjectionToken } from '@angular/core';
import { CoreConfig } from '@ntap/core';
import { MainListViewComponent } from '../app/components/main-listview/main-listview.component';

export const GENERAL_CONFIG = new InjectionToken('general.config');

export const MAIN_VIEW_COMPONENT = MainListViewComponent;

// NTAP config params
export const DEFAULT_ITEMVIEW_VIEWNAME = '$defaultItemView';

export function ntapEnvironment(apiUrl: string): CoreConfig {
  const API_HOST = apiUrl;
  const PATH_API = API_HOST + 'api';
  const PATH_API_NTAP = PATH_API + '/ntap';
  const PATH_API_NTAP_AUTH = PATH_API_NTAP + '/auth';
  const PATH_API_NTAP_REPO = PATH_API_NTAP + '/repo';

  // default NTAP controller endpoints()
  const PATH_API_NTAP_EXECUTE_ACTION = PATH_API_NTAP_REPO + '/executeAction';

  const DEFAULT_ROUTE = 'moji_zadaci';
  const AUTHENTICATION_ENDPOINT_LOGOUT = PATH_API_NTAP_AUTH + '/logout';
  const AUTHENTICATION_ENDPOINT_AUTHENTICATE =
    PATH_API_NTAP_AUTH + '/authenticate';
  const CSRF_TOKEN_URL = API_HOST + 'util/getCsrfToken';
  const HELP_LINK_URL = 'assets/help-reference/help.html';
  const PATH_API_NTAP_MENUS = PATH_API_NTAP_REPO + '/getAllowedMenus';

  return {
    defaultItemViewViewName: DEFAULT_ITEMVIEW_VIEWNAME,
    pathApiNtap: PATH_API_NTAP,
    ntapExecuteActionEndpoint: PATH_API_NTAP_EXECUTE_ACTION,
    authenticationEndpointLogout: AUTHENTICATION_ENDPOINT_LOGOUT,
    authenticationEndpointAuthenticate: AUTHENTICATION_ENDPOINT_AUTHENTICATE,
    csrfTokenEndpoint: CSRF_TOKEN_URL,
    helpUrl: HELP_LINK_URL,
    menuUrl: PATH_API_NTAP_MENUS,
    defaultView: DEFAULT_ROUTE,
    paginatorPageItems: 15,
    dateAutoGuess: true,
    pathApiNtapContent: `${PATH_API_NTAP}/content`,
    debounceDelay: 400,
    roleRouteMappings: {
      Superuser: '/view/ntap_type',
      'Djelatnik arhiva': '/view/moji_zadaci'
    }
  };
}
